export const SLIDE_IN_WIDTH = 480
export const SECONDARY_SLIDE_IN_WIDTH = '400px'

/**
 * marker types allowed as `?match=` URL entry for single-marker fetch
 * miniLot is excluded: no marker; restored via the `ml` param instead.
 */
export const MATCH_URL_ENTRY_TYPES = ['lot', 'pop'] as const
